import React from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import intlShape from '@/shared/utils/intlShape';
import FormGroupPart from './FormGroupPart';
import messages from '../registrationMessages';
import InputGroupWrapper from '../../InputGroupWrapper';
import CurrencySymbol from '../../CurrencySymbol';
import NumberInput from '../../input/NumberInput';

const TotalAmountPart = ({
  value,
  readOnly,
  disabled,
  isFixedPrice,
  intl,
  onChange,
  className,
}) => (
  <FormGroupPart label={messages.TotalExcl}>
    <InputGroupWrapper
      className={classnames('input-group-sm', { disabled: disabled }, className)}
      left={<CurrencySymbol />}
    >
      <NumberInput
        id="totalAmountField"
        min={0}
        disabled={disabled}
        readOnly={readOnly}
        value={value}
        onChange={onChange}
        className="form-control"
      />
      {isFixedPrice ? (
        <span
          className="input-group-addon"
          title={intl.formatMessage(messages.ResourceFixedPriceTooltip)}
        >
          <i className="fa fa-info" />
        </span>
      ) : null}
    </InputGroupWrapper>
  </FormGroupPart>
);

TotalAmountPart.propTypes = {
  value: PropTypes.number,
  isFixedPrice: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  intl: intlShape.isRequired,
};
TotalAmountPart.defaultProps = {
  value: 0,
  isFixedPrice: false,
  disabled: false,
  readOnly: false,
  onChange: () => {},
  className: '',
};
export default TotalAmountPart;
